// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-460f495c] .hero .hero-content{max-width:none}[data-v-460f495c] .hero .hero-pattern>.man{position:absolute!important;bottom:-3rem!important;left:-1rem!important;height:auto!important;width:auto!important;max-width:341px!important}.toolbar[data-v-460f495c]{height:52px}.view-funding__more[data-v-460f495c]{text-align:center}.beware[data-v-460f495c]{border-top:1px solid #979797;padding:1.875rem 0;color:rgba(0,0,0,.54);font-size:1rem;line-height:1.25rem;letter-spacing:-.5px}", ""]);
// Exports
module.exports = exports;
